module.exports = __webpack_public_path__ + "img/christianjesuschildlovejpg.eb8c9289.jpg";